import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const OrgUserDetailsHolder = styled(FlexColumnDiv) `
    width: 100%;
    gap: 16px;
    align-self: stretch;
    flex-grow: 1;
`;
